import { CompositionSplitCard } from "../common/CompositionSplit/CompositionSplitCard"
import { UnitProps } from "../unitTypes"

export function SplitMainTab(props: UnitProps) {
  const {data, unit} = props;
  const splitterUnit = data?.units?.LIQUID_SPLITTER || {};
  return <CompositionSplitCard className='mt-1' data={splitterUnit} unit={unit} splitterId={splitterUnit.uuid}/>
}